module.exports = __webpack_public_path__ + "static/0-aa65fa8cf95f5b29689f4186ff82ca01.png";